// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const setClaimMode = (state, action) => action.isEditable;

export default (state = getClaimDefaultState().isEditable, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_NORMAL_IS_EDITABLE]: setClaimMode,
        [actions.UPDATE_CLAIM_PARTS_IS_EDITABLE]: setClaimMode,
        [actions.UPDATE_CLAIM_PIP_IS_EDITABLE]: setClaimMode,
        [actions.UPDATE_CLAIM_BATTERY_IS_EDITABLE]: setClaimMode
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claim-search/reducers/revise-claim.js